import React from 'react';
import { STEPS } from '../data/content';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function Steps() {
  return <section id="como-funciona" className="border-y border-line bg-white py-16 sm:py-24" data-id="element-197" data-mp="18g7g022a1i33">
      <div className="mx-auto max-w-[1240px] px-4 sm:px-6 lg:px-8" data-id="element-198" data-mp="umg78vwde28f">
        <Reveal className="mx-auto max-w-2xl text-center" data-id="element-199" data-mp="yn8h9rd2gb5r">
          <p className="text-[11px] font-semibold uppercase tracking-overline text-brand-600" data-id="element-200" data-mp="koikkcu5sdhx">
            Cómo funciona
          </p>
          <h2 className="mt-4 text-[1.9rem] font-semibold leading-[1.1] tracking-[-0.025em] text-ink-900 sm:text-[2.6rem]" data-id="element-201" data-mp="pon0o1r5n67m">
            Comienza en 3 pasos
          </h2>
        </Reveal>

        <ol className="relative mx-auto mt-10 grid max-w-5xl gap-8 sm:mt-14 lg:grid-cols-3 lg:gap-8" data-id="element-202" data-mp="fonrq3qtpdu8">
          {/* Connector: vertical on mobile, horizontal on desktop */}
          <span aria-hidden="true" className="absolute bottom-8 left-6 top-8 w-px bg-brand-100 lg:hidden" data-id="element-203" data-mp="2a3gk7twetohy" />
          <span aria-hidden="true" className="absolute left-7 top-7 hidden h-px w-[calc(100%-3.5rem)] bg-gradient-to-r from-brand-200 via-brand-200 to-transparent lg:block" data-id="element-204" data-mp="1qaamwzxzyud7" />
          {STEPS.map((step, i) => <Reveal key={step.number} delay={i * 0.07} className="h-full" data-id="element-205" data-mp="202zsje6v9e0m" data-mpi={i}>
              <li className="relative flex h-full gap-5 lg:flex-col lg:gap-0" data-id="element-206" data-mp="1v2u8aj2xetsk">
                <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-brand-600 text-[14px] font-semibold text-white shadow-cta ring-8 ring-white lg:h-14 lg:w-14 lg:text-[15px]" data-id="element-207" data-mp="17d9ef558ic4i">
                  {step.number}
                </span>
                <div className="pt-1 lg:pt-0" data-id="element-208" data-mp="1cbue93gkqtsf">
                  <h3 className="text-[17px] font-semibold tracking-[-0.01em] text-ink-900 lg:mt-6 lg:text-[18px]" data-id="element-209" data-mp="1carl0ovs4f9c">
                    {step.title.charAt(0) + step.title.slice(1).toLowerCase()}
                  </h3>
                  <p className="mt-2 max-w-sm text-[14.5px] leading-relaxed text-ink-500 lg:mt-3" data-id="element-210" data-mp="2nqg8riguxib7">
                    {step.description}
                  </p>
                </div>
              </li>
            </Reveal>)}
        </ol>

        <Reveal delay={0.1} data-id="element-211" data-mp="34rkix4p34dgx">
          <div className="mt-12 text-center sm:mt-14" data-id="element-212" data-mp="34tf2ofomdzjf">
            <CTAButton label="Crear mi cuenta" location="steps" size="lg" className="w-full sm:w-auto" data-id="element-213" data-mp="39qx3tjwebagv" />
          </div>
        </Reveal>
      </div>
    </section>;
}